import Emitter from '@resources/js/helpers/Emitter'


class Toggle extends Emitter {
	constructor(triggerSelector, { target: targetElOrSelector, toggleClass = 'active' } = {}) {
		super()
		this.toggleClass = toggleClass
		if(triggerSelector)
			this.trigger = triggerSelector instanceof HTMLElement ? triggerSelector : document.querySelector(triggerSelector)

		const targetFromParam = targetElOrSelector instanceof HTMLElement
			? targetElOrSelector
			: document.querySelector(targetElOrSelector)
		this.target = targetFromParam || document.querySelector(this.trigger?.dataset.target)

		if (!this.target)
			throw new Error(`Error in Toggle. Cannot find target with selector ${targetElOrSelector} or data-attribute ${this.trigger?.dataset.target}`)

		this._clickListener = e => {
			e.currentTarget.blur()
			this.toggle()
		}

		this.trigger?.addEventListener('click', this._clickListener)
	}

	get active() {
		return this.target.classList.contains(this.toggleClass)
	}

	toggle() {
		this.target.classList.contains(this.toggleClass) ? this.hide() : this.show()
	}

	hide() {
		this.target.classList.remove(this.toggleClass)
		this.trigger?.classList.remove(this.toggleClass)
	}

	show() {
		this.target.classList.add(this.toggleClass)
		this.trigger?.classList.add(this.toggleClass)
	}

	destroy() {
		this.trigger?.removeEventListener('click', this._clickListener)
	}
}

// TODO: find better solution
export class ScrollToggle extends Toggle {
    constructor(triggerSelector, { target: targetElOrSelector, toggleClass = 'active', transition = '0.3s' } = {}) {
        super(triggerSelector, { target: targetElOrSelector, toggleClass: toggleClass })

        this._targetHeight = this.target.offsetHeight
        this.target.style.transition = transition
        this.target.style.overflow = 'hidden'
    }

    hide() {
		super.hide()
        this.target.style.height = '0'
	}

    show() {
		super.show()
        this.target.style.height = `${this._targetHeight}px`
	}
}

export class ToggleWithScroll extends Toggle {
	constructor(triggerSelector) {
		super(triggerSelector)
	}

	toggle() {
		super.toggle()
		this._scrollToViewport()
	}

	_scrollToViewport() {
		const offset = 150
		const bodyRect = document.body.getBoundingClientRect().top
		const elementRect = this.target.getBoundingClientRect().top
		const elementPosition = elementRect - bodyRect
		const offsetPosition = elementPosition - offset

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		})
	}
}

export default Toggle
